import { UPPER_TOOTH_DESIGN } from '@witmetrics/unison-core';

const {
  OVAL,
  RECTANGLE,
  RECTANGLE_OVAL,
  RECTANGLE_ROUND,
  SQUARE_ROUND,
  TRAPEZOID,
  TRIANGLE,
} = UPPER_TOOTH_DESIGN;

export const TOOTH_DESIGN_OPTIONS = [
  { value: OVAL, label: 'Oval' },
  { value: RECTANGLE, label: 'Rectangle' },
  { value: RECTANGLE_OVAL, label: 'Rectangle Oval' },
  { value: RECTANGLE_ROUND, label: 'Rectangle Round' },
  { value: SQUARE_ROUND, label: 'Square Round' },
  { value: TRAPEZOID, label: 'Trapezoid' },
  { value: TRIANGLE, label: 'Triangle' },
];
